import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/hokify/hokify/apps/international-page-app/src/layouts/default.vue").then(m => m.default || m)),
  headerless: defineAsyncComponent(() => import("/home/runner/work/hokify/hokify/apps/international-page-app/src/layouts/headerless.vue").then(m => m.default || m))
}